module.exports = __webpack_public_path__ + "static/01_corezoid-visa-privatbank-teams-cf45dc57e98272f9cfa9e42e505f571c.jpg";